import { useRef } from 'react';
import '@/App.css';
import { Toaster } from './components/ui/sonner';

// Landing page components
import { Header } from './components/landing/Header';
import { HeroSection } from './components/landing/HeroSection';
import { BenefitsSection } from './components/landing/BenefitsSection';
import { WhyUsSection } from './components/landing/WhyUsSection';
import { TeamSection } from './components/landing/TeamSection';
import { ProcessSection } from './components/landing/ProcessSection';
import { FAQSection } from './components/landing/FAQSection';
import { SocialProofSection } from './components/landing/SocialProofSection';
import { ContactSection } from './components/landing/ContactSection';
import { Footer } from './components/landing/Footer';
import { StickyCTA } from './components/landing/StickyCTA';

// SEO meta component
const SEOHead = () => {
  return null; // Meta tags are in public/index.html
};

function App() {
  const contactRef = useRef(null);

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen bg-[#FAFAFA]" data-testid="app-container">
      <SEOHead />
      <Toaster position="top-center" />
      
      {/* Header */}
      <Header onCtaClick={scrollToContact} />

      {/* Main content */}
      <main>
        {/* Hero Section */}
        <HeroSection onCtaClick={scrollToContact} />

        {/* Benefits Section */}
        <BenefitsSection />

        {/* Why Us Section */}
        <WhyUsSection />

        {/* Team Section */}
        <TeamSection />

        {/* Process Section */}
        <ProcessSection />

        {/* Social Proof Section */}
        <SocialProofSection />

        {/* FAQ Section */}
        <FAQSection />

        {/* Contact Section */}
        <ContactSection ref={contactRef} />
      </main>

      {/* Footer */}
      <Footer />

      {/* Sticky CTA (Mobile only) */}
      <StickyCTA onCtaClick={scrollToContact} />
    </div>
  );
}

export default App;
